import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {catchError, EMPTY, Observable, throwError} from 'rxjs';
import {CookieService} from 'ngx-cookie';
import {ErrorsService} from '../errors/errors.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private _cookieService: CookieService,
    private _errorsService: ErrorsService,
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this._cookieService.get('token');
    if (
      !req.url.includes('login') &&
      !req.url.includes('restore_password') &&
      !req.url.includes('verify') &&
      !req.url.includes('register') &&
      !req.url.includes('spheres')
    ) {
      if (token)
        return next
          .handle(
            req.clone({
              setHeaders: {
                Authorization: token,
              },
            }),
          )
          .pipe(
            // map(data => {
            //   console.log(req, data);
            //   return data
            // }),
            catchError((err: HttpErrorResponse) => {
              console.log('intercept:', err);
              if (err.status === 403) {
                return EMPTY;
              }
              this._errorsService.openPopup(err);
              return throwError([]);
            }),
          );
    }
    return next.handle(req);
  }
}
